import { create } from "zustand";

const useEventStore = create((set) => ({
  currentContentTab: {
    id: 1,
    name: "Overview",
  },
  setCurrentContentTab: (value) => set({ currentContentTab: value }),
}));

export default useEventStore;
